<template>
    <div>
        <!-- Tabela -->

        <v-card class="ma-2 main-card">

             <v-toolbar flat dense>
                    <v-toolbar-title>{{$t('provider_dashboard.areas')}}</v-toolbar-title>                   
            </v-toolbar>

            <v-card-title class="main-title">
                <v-row>

                    <v-col cols='12' md='6' class="d-flex justify-center align-center" >

                       <v-select chips item-text="name" item-value='_id' @change="filterByCity" v-model="citiesFilter" append-outer-icon="mdi-city" :items="areas.cities" :label="$t('provider_dashboard.filter_by_city')" attach multiple ></v-select>

                    </v-col>

                </v-row>

            </v-card-title>

            <v-data-table disable-sort hide-default-footer class="datatable-1" @update:page='showPage($event)' :server-items-length="total" v-model="selectedAreas" item-key="_id" :headers="headers" :items="areas ? areas.rows : []" :loading='loading' show-select >

                <template v-slot:item.name="props">
                    <v-edit-dialog :return-value.sync="props.item.name" @save="updateName(props.item)">
                        {{ props.item.name }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.name" label="Edit" single-line counter></v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>

                <template v-slot:item.created_at="{ item }">

                    <span>{{ item.created_at | dateFormat }}</span>

                </template>

                <template v-slot:item.mSquare="{ item }">

                    <span>{{ item.kmSquare }}</span>

                </template>

                <template v-slot:item.cities="{ item }">

                    <div v-if="item.cities">

                        <div v-if="item.cities.length > 1">
                           
                            <v-tooltip top color='white'>
                                <template v-slot:activator="{ on }">
                                    <v-chip v-on="on"> {{ item.cities[0].name }} + {{item.cities.length - 1 }} </v-chip>
                                </template>
                                <v-list >
                                    <v-list-item v-for="(item, i) of item.cities" :key="i">{{ item.name }}</v-list-item>                                  
                                </v-list>
                            </v-tooltip>

                        </div>

                        <v-chip v-else>{{ item.cities.length ?  item.cities[0].name : '-' }}</v-chip>

                    </div>
                    
                </template>

                <template v-slot:item.enabled="{ item }">

                    <div :class="`icon-${item.name}`" class="d-flex align-center">

                        <v-icon v-if="item.enabled" color='green'>mdi-check-circle-outline</v-icon>
                        <v-icon v-else color='red'>mdi-window-close</v-icon>

                    </div>

                </template>

            </v-data-table>

            <!-- Footer da tabela  -->

            <v-footer class="footer-table" padless>
                <v-col class="text-center" cols="12">
                    <div>
                        <v-btn @click="backPage" :disabled='this.page === 1' :loading='loading' icon>
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-chip outlined> {{ this.page }} - {{ this.totalPagesCalc }} </v-chip>
                        <v-btn @click="nextPage" :disabled='this.page === this.totalPagesCalc' :loading='loading' icon>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </v-col>
            </v-footer>

            <!-- Botão de Opções  -->

            <v-btn :loading='loading' :disabled='!selectedAreas.length' class="btn-block" @click="configArea" block>
                <v-icon class="mr-2">mdi-cog</v-icon>
                <span>{{$t('areas_dashboard.options')}}</span>
            </v-btn>

        </v-card>

        <!-- Modal Escolha 1 -->

        <v-dialog v-if="dialog" v-model="dialog" hide-overlay transition="dialog-bottom-transition">

            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('provider_dashboard.config')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-list three-line>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn fab icon @click="confirmAction('changeStatus')">
                                <v-icon color="green">mdi-check</v-icon>
                                <v-icon color="red">mdi-cancel</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-content>

                            <v-list-item-title>{{$t('provider_dashboard.activate')}} / {{$t('provider_dashboard.deactivate')}}</v-list-item-title>
                            <v-list-item-subtitle>{{$t('provider_dashboard.change_status')}}</v-list-item-subtitle>

                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn fab icon color='red' @click="confirmAction('delete')">
                                <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('provider_dashboard.delete_areas')}}</v-list-item-title>
                            <v-list-item-subtitle>{{$t('provider_dashboard.delete_areas_msg')}}</v-list-item-subtitle>
                        </v-list-item-content>

                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>


        <!-- Modal Preview Areas -->

        <v-dialog v-if="dialogPreview" v-model="dialogPreview" hide-overlay transition="dialog-bottom-transition">

            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('provider_dashboard.config')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-list three-line>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn fab icon color='red' @click="confirmAction('deletePreview')">
                                <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('provider_dashboard.delete')}}</v-list-item-title>
                            <v-list-item-subtitle>{{$t('provider_dashboard.delete_msg')}}</v-list-item-subtitle>
                        </v-list-item-content>

                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>

        <!-- Modal Confirmar -->

        <v-dialog v-if="dialog2" v-model="dialog2" hide-overlay transition="dialog-bottom-transition">

            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('provider_dashboard.config')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog2 = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-list>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn fab icon color='green' @click="doAction">
                                <v-icon>mdi-check-circle</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-content>

                            <v-list-item-title>{{$t('provider_dashboard.confirm_action')}}</v-list-item-title>

                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>

        <!-- Modal Cidades -->

        <v-dialog maxWidth='600' v-if="dialogCity" v-model="dialogCity" hide-overlay transition="dialog-bottom-transition">

            <v-card maxWidth='600'>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('areas_dashboard.cities_covered')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogCity = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
             
                <v-list dense>
                    <v-list-item-group color="primary">
                        <v-list-item v-for="(item, i) in areas ? areas.cities : []" :key="i">
                            <v-list-item-content>
                                <v-list-item-title v-text="item"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
                                
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import {DELETE_AREAS, UPDATE_AREAS, GET_TABLE_AREAS} from '../../../store/mutations'
import dayjs from 'dayjs';
import vueI18n from '../../../plugins/vue-i18n' 

export default {
    name: 'AreaTableData',

    data() {
        return {
            search: null,
            areasData: null,
            dialog: false,
            dialog2: false,
            dialogCity: false,
            area: null,
            action: null,
            loading: false,
            alert: true,
            page: 1,
            selectedAreas: [],
            dialogPreview: false,
            citiesFilter: []

        
        }
    },

    props: ['areas', 'provider', 'user', 'total'],

    filters: {

        dateFormat(date) {

            return dayjs(date).format('DD/MM/YYYY')

        },

    },

    computed: {

        headers () {
                return [
                        { text: vueI18n.t('provider_dashboard.name_h'), value: 'name' },
                        { text: vueI18n.t('provider_dashboard.location_h'), value: 'cities' },
                        { text: vueI18n.t('provider_dashboard.km2'), value: 'kmSquare' },
                        { text: vueI18n.t('provider_dashboard.created_h') , value: 'created_at' },
                        { text: vueI18n.t('provider_dashboard.active_h'), value: 'enabled' },
                   
                ]
        },

        totalPagesCalc() {

            if (!this.total) return 0

            return Math.ceil(this.total / 25) 

        },
    },

    methods: {

        async uploadCompleted() {

            this.loading = true

            await this.getAreasById({page: this.page, id: this.provider ? this.provider._id : 0, cities: this.citiesFilter }) 

            this.loading = false

        },

        async showPage(event) {

            this.loading = true

            this.page = event

            await this.getAreasById({page: this.page, id: this.provider ? this.provider._id : 0, cities: this.citiesFilter })

            this.loading = false


        },

        async backPage() {

                this.loading = true

                const newPage = this.page - 1

                await this.updatePage(newPage)
       
                await this.getAreasById({page: this.page, id: this.provider._id, cities: this.citiesFilter})

                this.loading = false 


            },

        async nextPage() {

            this.loading = true

            const newPage = this.page + 1

            await this.updatePage(newPage)
        
            await this.getAreasById({page: this.page, id: this.provider._id, cities: this.citiesFilter})

            this.loading = false 

        },

        async updatePage(newPage) {

            this.page = newPage

        },

        ...mapActions({
                getAreasById: `AreaVuex/${GET_TABLE_AREAS}`,
                delete: `AreaVuex/${DELETE_AREAS}`,
                update: `AreaVuex/${UPDATE_AREAS}`,
                removeFromPreview: `AreaVuex/${UPDATE_AREAS}`,

        }),

        configArea() {

            this.dialog = true;

        },

        confirmAction(action) {

            this.showToast(this.$t('provider_dashboard.confirm_msg'), this.$t('provider_dashboard.confirm_title'), 'warning')

            this.dialog = false
            this.dialog2 = true

            if (action === 'delete') return  this.action = 'delete'
            if (action === 'deletePreview') return  this.action = 'deletePreview'
            if (action === 'changeStatus') return  this.action = 'changeStatus'

        },

        doAction() {

            if (this.action === 'delete') this.deleteAreas()

            else if (this.action === 'deletePreview') this.removePreviewAreas()

            else this.updateSituation(this.action)

            return this.action = null

        },

        async deleteAreas() {

                this.loading = true;

                let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

                const areasToDelete = this.selectedAreas.map(area => area._id)

                try {

                        await this.delete(areasToDelete)

                        await this.getAreasById({page: this.page, id: this.provider ? this.provider._id : 0, cities: this.citiesFilter })                          

                        return this.showToast(this.$t('provider_dashboard.toast_area_delete_msg'), this.$t('provider_dashboard.toast_area_delete_title'), 'success')

                } catch (error) {                  

                        return this.showToast(error.message, this.$t('provider_dashboard.toast_area_error_delete_title'), 'error')

                } finally {

                        this.loading = false;
                        this.selectedAreas = [];
                        this.dialog2 = false;
                        loader.hide();

                }

        },

        async removePreviewAreas() {

                this.loading = true;

                let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

                try {

                        await this.removeFromPreview(this.selectedAreas)                       

                        return this.showToast(this.$t('provider_dashboard.toast_area_delete_msg'), this.$t('provider_dashboard.toast_area_delete_title'), 'success')

                } catch (error) {                  

                        return this.showToast(error.message, this.$t('provider_dashboard.toast_area_error_delete_title'), 'error')

                } finally {

                        this.loading = false;
                        this.selectedAreas = [];
                        loader.hide();

                }

        },

        async updateSituation() {

                this.loading = true;

                let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

                const areasToUpdate = this.selectedAreas.map(area => {
                        area.enabled = !area.enabled
                        return area
                })

                try {

                        await this.update({ areasToUpdate }) 
                        
                        await this.getAreasById({page: this.page, id: this.provider ? this.provider._id : 0, cities: this.citiesFilter }) 

                        return this.showToast(this.$t('provider_dashboard.toast_area_update_msg'), this.$t('provider_dashboard.toast_area_update_title'), 'success')

                } catch (error) {

                        console.log(error)

                        return this.showToast(error.message, this.$t('provider_dashboard.toast_area_error_update_title'), 'error')

                } finally {

                        this.loading = false;
                        this.selectedAreas = []
                        this.dialog2 = false
                        loader.hide();

                }

        },

        async updateName(area) {

                this.loading = true

                let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

                try {

                        await this.update({ areasToUpdate: [area] }) 
                        
                        await this.getAreasById({page: this.page, id: this.provider ? this.provider._id : 0, cities: this.citiesFilter }) 

                        return this.showToast(this.$t('provider_dashboard.toast_area_update_msg'), this.$t('provider_dashboard.toast_area_update_title'), 'success')

                } catch (error) {

                        console.log(error)

                        return this.showToast(error.message, this.$t('provider_dashboard.toast_area_error_update_title'), 'error')

                } finally {

                        this.loading = false;
                        loader.hide();

                }

        },

        async filterByCity(cities) {

                this.loading = true

                let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

                try {
                        
                        await this.getAreasById({page: this.page, id: this.provider ? this.provider._id : 0, cities }) 

                        return this.showToast(this.$t('provider_dashboard.filter_update_msg'), this.$t('provider_dashboard.filter_update_title'), 'success')

                } catch (error) {

                        console.log(error)

                        return this.showToast(error.message, this.$t('provider_dashboard.toast_area_error_update_title'), 'error')

                } finally {

                        this.loading = false;
                        loader.hide();

                }

        },

  
    }, 



}

</script>

<style>

</style>
